var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"Text-Title",style:(_vm.backgroundStyle)},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }